export enum ChurchInformation {
	ENGLISH_SERVICE_TIME = '10:00 AM',
	UKRAINIAN_SERVICE_TIME = '12:00 PM',
	CHURCH_ADDRESS = '13601 Idlewild Rd, Matthews, NC 28105',
	CHURCH_PHONE = '+1 (704) 609-7110'
}